// extracted by mini-css-extract-plugin
export default {"root":"_3nP0D","link-overlay":"_3NVQU","linkOverlay":"_3NVQU"};